<script>
import TextInput from "../../../../Shared/TextInput.vue";
import TabLayout from "../../Shared/TabLayout.vue";

export default {
    name: "Create",
    metaInfo: { title: Lang.get('employeedashboard::pages/settings/recovery/email-recovery.edit.title') },
    components: { TextInput, TabLayout },
    props: {
        errors: Object,
        able_to_delete_recovery_email: Boolean,
    },
    data() {
        return {
            form: this.$inertia.form({
                recovery_email: null,
                password: null,
            }),
            deleteForm: this.$inertia.form({
                password_for_deletion: null,
            }),
        }
    },
    methods: {
        submit() {
            this.form.post(
                this.route('nl.employeedashboard.settings.recovery-mail.update.pre')
            )
        },
        submitDeletion() {
            this.deleteForm.delete(
                this.route('nl.employeedashboard.settings.recovery-mail.destroy'),
            )
        },
        resetForm() {
            this.deleteForm.password_for_deletion = null
        },
    },
    mounted() {
        this.form.recovery_email = this.$page.props.recovery_email
    }
}
</script>

<template>
    <TabLayout
        :title="Lang.get('employeedashboard::pages/settings/recovery/email-recovery.edit.title')"
        :subtitle="Lang.get('employeedashboard::pages/settings/recovery/email-recovery.edit.subtitle')"
        tabName="profile"
        :hideMsg="true"
    >
        <p>{{ Lang.get('employeedashboard::pages/settings/recovery/email-recovery.edit.description') }}</p>
        <form @submit.prevent="submit">
            <text-input
                class="w-75 mb-4"
                id="recovery_email"
                v-model="form.recovery_email"
                type="email"
                :label="Lang.get('employeedashboard::pages/settings/recovery/email-recovery.form.recovery_email.label')"
                :error="errors.recovery_email"
            />

            <text-input
                class="w-75"
                id="password"
                v-model="form.password"
                type="password"
                :label="Lang.get('generic.password')"
                :error="errors.password"
            />

            <div class="d-flex mt-4 align-items-center">
                <button type="submit"
                        class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4 mr-2"
                        :disabled="form.processing">
                {{ Lang.get('generic.change') }}
                </button>
                <button type="button"
                        data-toggle="modal"
                        data-target="#deleteRecoveryEmailModal"
                        class="btn btn-link font-poppins font-weight-light color-blue hover-color-red"
                        :disabled="form.processing">
                    {{ Lang.get('generic.delete') }}
                </button>
            </div>
        </form>

        <div class="modal fade" id="deleteRecoveryEmailModal" tabindex="-1" role="dialog"
             aria-labelledby="deleteRecoveryEmailModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <form @submit.prevent="submitDeletion">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="deleteRecoveryEmailModalLabel">
                                {{
                                    Lang.get('employeedashboard::pages/settings/recovery/email-recovery.modals.delete.title')
                                }}
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="resetForm">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <template v-if="able_to_delete_recovery_email">
                                <p v-html="Lang.get('employeedashboard::pages/settings/recovery/email-recovery.modals.delete.body_deletable')" />
                                <text-input
                                    class="w-75"
                                    id="password"
                                    v-model="deleteForm.password_for_deletion"
                                    type="password"
                                    :label="Lang.get('generic.password')"
                                    :error="errors.password_for_deletion"
                                />
                            </template>

                            <template v-else>
                                <p>{{
                                        Lang.get('employeedashboard::pages/settings/recovery/email-recovery.modals.delete.body_not_deletable')
                                    }}</p>
                            </template>
                        </div>
                        <div class="modal-footer">
                            <template v-if="able_to_delete_recovery_email">
                                <button class="btn btn-link font-poppins font-weight-light color-blue hover-color-red"
                                        type="submit"
                                        :disabled="deleteForm.processing">
                                    {{ Lang.get('generic.delete') }}
                                </button>
                            </template>

                            <button type="button"
                                    class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4 mr-2"
                                    data-dismiss="modal"
                                    @click="resetForm">
                                {{
                                    able_to_delete_recovery_email
                                        ? Lang.get('employeedashboard::pages/settings/recovery/email-recovery.modals.delete.cancel_deletable')
                                        : Lang.get('employeedashboard::shared.close')
                                }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </TabLayout>
</template>

<style scoped>
.btn-link:focus, .btn-link:focus-visible {
    box-shadow: none;
}

.hover-color-red:hover {
    color: #F7495E;
}
</style>
